const MARKETING_HERO_CONSTANTS = {
  YES_CONSTANT: 'YES',
  NO_CONSTANT: 'NO',
  SLIDE_CHANGE_INTERVAL: 5000,
  LIGHT: 'LIGHT',
  BLACK_COLOR: '#202124',
  WHITE_COLOR: '#ffffff',
  CAROUSEL_IMAGE_CLICK: 'carouselImgClick',
  daysOfTheWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  localizedUserSampleData: { type: '', store: { id: '', name: [{ value: '' }] } },
};

export default MARKETING_HERO_CONSTANTS;
